import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    newRecord: { type: Boolean, default: false }
  }

  cancel(event) {
    if (this.newRecordValue) {
      event.preventDefault()
      event.stopPropagation()
      this.turboFrame.remove()
    }
  }

  get turboFrame() {
    return this.element.closest('turbo-frame')
  }
}
